import { Dispatch, SetStateAction } from "react";
import { DatosGenerales } from "../../../../../types/empresa"
import { DatosGeneralesText } from "../../../../../components/ui/DatosGeneralesText";
import { useSelector } from 'react-redux';
import { EditComments } from "./EditComments";
import { selectCurrentUser } from "../../../../../api/auth/authSlice";
import { ReadOnlyComments } from "./ReadOnlyComments";
import { selectGeneralInfo } from "../../../../../store/empresaSelectedSlice";
import Groups2RoundedIcon from '@mui/icons-material/Groups2Rounded';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import NumbersRoundedIcon from '@mui/icons-material/NumbersRounded';
import SignpostRoundedIcon from '@mui/icons-material/SignpostRounded';
import ToggleOnRoundedIcon from '@mui/icons-material/ToggleOnRounded';
import FmdGoodRoundedIcon from '@mui/icons-material/FmdGoodRounded';
import DialpadRoundedIcon from '@mui/icons-material/DialpadRounded';
import AccountBalanceRoundedIcon from '@mui/icons-material/AccountBalanceRounded';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import ClearRoundedIcon from '@mui/icons-material/ClearRounded';
import CategoryRoundedIcon from '@mui/icons-material/CategoryRounded';

interface Props {
    empresaId: number;
    datosGenerales?: DatosGenerales;
    setShowEdit: Dispatch<SetStateAction<boolean>>;
    showEdit: boolean;
}

export function EmpresaDatosGenerales({ empresaId, datosGenerales, setShowEdit, showEdit }: Props) {
    const iconSize = 20;

    const prospectadorAsignadoId = useSelector(selectGeneralInfo)?.prospectadorAsignadoId;
    const user = useSelector(selectCurrentUser); // TODO: Traer solo el id del current user

    const stateColor = datosGenerales?.estado === "Inactiva" ? "red" : "green"

    return (
        <div>
            <div className="flex justify-between">
                <DatosGeneralesText 
                    icon={<Groups2RoundedIcon sx={{ height: iconSize, width: iconSize }}/>}
                    label={"No. Trabajadores: "}
                    text={`${datosGenerales?.numeroTrabajadores}`}/>

                <div 
                    className="hover:bg-gray-100 rounded-md w-[25px] h-[25px] flex justify-center items-center cursor-pointer"
                    onClick={() => setShowEdit(!showEdit)}>
                    {showEdit
                    ? <ClearRoundedIcon sx={{ height: 20, width: 20, color: "#4b5563"}}/>
                    : <EditRoundedIcon sx={{ height: 20, width: 20, color: "#4b5563"}}/>
                    }
                </div>
            </div>

            <DatosGeneralesText 
                icon={<ToggleOnRoundedIcon sx={{ height: iconSize, width: iconSize, color: stateColor }}/>}
                label={"Estado: "}
                text={datosGenerales?.estado}/>

            <DatosGeneralesText 
                icon={<CategoryRoundedIcon sx={{ height: iconSize, width: iconSize }}/>}
                label={"Tipo: "}
                text={datosGenerales?.tipo}/>

            <DatosGeneralesText 
                icon={<HomeRoundedIcon sx={{ height: iconSize, width: iconSize }}/>}
                label={"Calle: "}
                text={datosGenerales?.calle}/>

            <DatosGeneralesText 
                icon={<SignpostRoundedIcon sx={{ height: iconSize, width: iconSize }}/>}
                label={"Colonia: "}
                text={datosGenerales?.colonia}/>

            <DatosGeneralesText 
                icon={<NumbersRoundedIcon sx={{ height: iconSize, width: iconSize }}/>}
                label={"No. Exterior: "}
                text={datosGenerales?.numeroExterior}/>

            <DatosGeneralesText 
                icon={<DialpadRoundedIcon sx={{ height: iconSize, width: iconSize }}/>}
                label={"Codigo Postal: "}
                text={datosGenerales?.codigoPostal}/>

            <DatosGeneralesText 
                icon={<AccountBalanceRoundedIcon sx={{ height: iconSize, width: iconSize }}/>}
                label={"Municipio: "}
                text={datosGenerales?.municipio}/>

            <DatosGeneralesText 
                icon={<FmdGoodRoundedIcon sx={{ height: iconSize, width: iconSize }}/>}
                label={"Coordenadas: "}
                text={datosGenerales?.coordenadas}/>
            
            {user?.id == prospectadorAsignadoId
            ?
            <EditComments 
                empresaId={empresaId}
                text={datosGenerales?.comentarios} />
            :
            <ReadOnlyComments 
               text={datosGenerales?.comentarios} />
            }

        </div>
    )
}
